import React, { useState, useRef,useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Form, Field } from "react-final-form";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import { useNavigate, Navigate } from "react-router-dom";
import PiedPage from "../../component/PiedPage";
import { Dialog } from "primereact/dialog";
import NousContacter from "../../component/NousContacter";
import { setAuthToken, instance } from "../../api";
import { useAuth } from "../../Context/AuthContext";
import "react-internet-meter/dist/index.css";
import { Toast } from "primereact/toast";  // Import Toast Component
import "./login.css";
//import { UserAgentApplication } from "msal";
import { PublicClientApplication } from "@azure/msal-browser";
// ⬆️ En dehors du composant Login (au niveau module)
import { msalInstance } from "../../msalConfig";



export default function Login({ setChecked, checked }) {
  const { login } = useAuth();
  const toast = useRef(null);
  // NEW: états MFA
const [mfaOpen, setMfaOpen] = useState(false);
const [mfaCode, setMfaCode] = useState("");
const [mfaChallengeId, setMfaChallengeId] = useState("");
const [rememberDevice, setRememberDevice] = useState(false);


// pour rejouer l'appel /login_check à la vérification
const [pendingCreds, setPendingCreds] = useState(null);
  const [user, setuser] = useState(false);
  const [openDialog, setDialog] = useState(false);

  const navigate = useNavigate();
  const otpInputRef = useRef(null);
  const OnSubmit = async (data) => {
  try {
    const response = await login(data); // axios response

    // ✅ Cas MFA demandée (202)
    if (response?.status === 202 && response?.data?.mfa_required) {
      setPendingCreds(data);
      setMfaChallengeId(response.data.challenge_id || "");
      setMfaCode("");
      setMfaOpen(true);
      toast.current?.show({
        severity: "info",
        summary: "Vérification requise",
        detail: "Un code à 6 chiffres vous a été envoyé par email.",
        life: 4000,
      });
      return; 
    }

    // ✅ Cas succès direct (200)
    const token = response?.data?.token;
    if (!token) {
      // garde-fou si jamais le backend ne renvoie pas le token
      throw new Error("TOKEN_ABSENT");
    }
    setAuthToken(token);
    if (data.remember) localStorage.setItem("tokenL", token);
    sessionStorage.setItem("token", token);
    await instance.post("/api/utilisateurs/add/connections", { login_date: Date.now() });
    navigate("/carte");

  } catch (error) {

    if (error.response?.status === 401 && error.response?.data?.message === "no_active_role") {
      toast.current.show({ 
        severity: "error", 
        summary: "Compte inactif", 
        detail: "Votre compte est inactif. Veuillez contacter l'administrateur.", 
        life: 5000 
      });
       return;
    }
    if (error.response?.status === 401 && error.response?.data?.message === "Client archived - access denied for user role") {
      toast.current.show({ 
        severity: "error", 
        summary: "Access denied",
        detail: "Access denied. Veuillez contacter l'administrateur.", 
        life: 5000 
      });
       return;
    }
    

    // Erreurs classiques
    if (error.response?.status === 401 && error.response?.data?.message === "Invalid credentials") {
      toast.current.show({ severity: "error", summary: "Erreur", detail: "Informations d'identification invalides", life: 3000 });
    } else if (error.response?.status === 401 && error.response?.data?.message === "not authorized") {
      toast.current.show({ severity: "error", summary: "Erreur", detail: "Accès non autorisé, veuillez nous contacter", life: 3000 });
    } else if (error.response?.status === 403) {
      toast.current.show({ severity: "error", summary: "Erreur", detail: "Erreur lors de l'authentification", life: 3000 });
    } else {
      toast.current.show({ severity: "error", summary: "Erreur", detail: "Une erreur est survenue", life: 3000 });
    }
  }
};

useEffect(() => {
  if (mfaOpen) {
    // focus automatique à l'ouverture du dialog
    setTimeout(() => otpInputRef.current?.focus?.(), 0);
  }
}, [mfaOpen]);
// Vérifier l'OTP
const [mfaLoading, setMfaLoading] = useState(false);


const handleVerifyMfa = async () => {
  if (!pendingCreds || mfaLoading) return;
  if (!/^\d{6}$/.test(mfaCode)) {
    toast.current.show({ severity: "warn", summary: "Code invalide", detail: "Entrez un code à 6 chiffres.", life: 3000 });
    return;
  }

  setMfaLoading(true);
  const payload = {
    ...pendingCreds,
    otp: mfaCode,
    challenge_id: mfaChallengeId,
    remember_device: rememberDevice,
  };
 

  try {
    // Conseil: appeler l'API directement ici (pas via un helper qui pourrait re-soumettre)
    const resp = await instance.post("/api/utilisateurs/login_check", payload, {
      // accepte 200 (ok) et 202 (expiré -> l’API peut renvoyer un nouveau challenge)
      validateStatus: (s) => s === 200 || s === 202 || s === 401,
    });

    if (resp.status === 200) {
      const token = resp.data.token;
      setAuthToken(token);
      if (pendingCreds.remember) localStorage.setItem("tokenL", token);
      sessionStorage.setItem("token", token);
      await instance.post("/api/utilisateurs/add/connections", { login_date: Date.now() });
      setMfaOpen(false);
      setPendingCreds(null);
      navigate("/carte");
      return;
    }

    if (resp.status === 202 && resp.data?.mfa_required && resp.data?.reason === "expired") {
      if (resp.data.challenge_id) setMfaChallengeId(resp.data.challenge_id);
      setMfaCode("");
      toast.current.show({ severity: "info", summary: "Code expiré", detail: "Un nouveau code vous a été envoyé.", life: 3000 });
      return;
    }

    // sinon 401
    toast.current.show({ severity: "error", summary: "Code incorrect", detail: "Veuillez réessayer.", life: 3000 });

  } catch (err) {
    toast.current.show({ severity: "error", summary: "Erreur", detail: "Impossible de valider le code.", life: 3000 });
  } finally {
    setMfaLoading(false);
  }
};

const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
const otpRefs = useRef(Array.from({ length: 6 }, () => React.createRef()));

const focusNext = (i) => {
  if (i < 5) otpRefs.current[i + 1]?.current?.focus();
};
const focusPrev = (i) => {
  if (i > 0) otpRefs.current[i - 1]?.current?.focus();
};

const syncMfaCode = (arr) => {
  const joined = arr.join("");
  setMfaCode(joined); // <- ton state existant
};

const handleOtpChange = (i, val) => {
  // ne garder qu’un chiffre
  const v = (val || "").replace(/\D/g, "").slice(0, 1);
  const next = [...otpDigits];
  next[i] = v;
  setOtpDigits(next);
  syncMfaCode(next);
  if (v) focusNext(i);
};

const handleOtpKeyDown = (i, e) => {
  if (e.key === "Backspace") {
    if (!otpDigits[i]) {
      e.preventDefault();
      focusPrev(i);
    } else {
      // effacer la case courante
      const next = [...otpDigits];
      next[i] = "";
      setOtpDigits(next);
      syncMfaCode(next);
    }
  }
  if (e.key === "ArrowLeft") {
    e.preventDefault(); focusPrev(i);
  }
  if (e.key === "ArrowRight") {
    e.preventDefault(); focusNext(i);
  }
};

const handleOtpPaste = (e) => {
  const text = (e.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, 6);
  if (!text) return;
  e.preventDefault();
  const next = ["", "", "", "", "", ""];
  for (let i = 0; i < text.length; i++) next[i] = text[i];
  setOtpDigits(next);
  syncMfaCode(next);
  // focus sur la dernière case remplie
  const last = Math.min(text.length - 1, 5);
  if (last >= 0) otpRefs.current[last]?.current?.focus();
};
// Renvoyer le code
const handleResendCode = async () => {
  if (!pendingCreds || mfaLoading) return;
  setMfaLoading(true);
  try {
    const r = await instance.post(
      "/api/utilisateurs/login_check",
      {
        ...pendingCreds,
        challenge_id: mfaChallengeId,
        resend: true,               // <= IMPORTANT
      },
      { validateStatus: (s) => s === 202 }
    );

    if (r?.status === 202 && r?.data?.mfa_required) {
      if (r.data.challenge_id) setMfaChallengeId(r.data.challenge_id);
      toast.current.show({ severity: "info", summary: "Code renvoyé", detail: "Vérifiez votre boîte mail.", life: 3000 });
    } else {
      toast.current.show({ severity: "info", summary: "Info", detail: "Un code a été renvoyé.", life: 3000 });
    }
  } catch (err) {
    toast.current.show({ severity: "error", summary: "Erreur", detail: "Impossible de renvoyer le code.", life: 3000 });
  } finally {
    setMfaLoading(false);
  }
};



  const validate = (data) => {
    let errors = {};

    if (!data.username) {
      errors.username = "Adresse mail requise.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,40}$/i.test(data.username)) {
      errors.username = "Adresse mail invalide";
    }

    if (!data.password) {
      errors.password = "Mot de passe requis.";
    }

    return errors;
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return (
      isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
    );
  };

  const onClick = () => {
    setDialog(true);
  };

  const onHide = () => {
    setDialog(false);
  };

  


 const handleLogin = async () => {
  try {
 // attendre que MSAL soit initialisé

    const loginResponse = await msalInstance.loginRedirect({
      scopes: ["openid", "profile", "email"],
    });

    const account = loginResponse.account;

    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: ["openid", "profile", "email"],
      account,
    });

    // Decode JWT payload to extract iat and exp
    const decodeJwt = (token) => {
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error("JWT decoding failed", e);
        return {};
      }
    };

    const claims = decodeJwt(tokenResponse.idToken);
    const iat = claims.iat || null;
    const exp = claims.exp || null;

    // Send required data to backend
    const response = await instance.post("/api/utilisateurs/login365", {
      username: account.username,
      email: account.username,
      token: tokenResponse.idToken,
      iat,
      exp,
    });

    const token = response.data.token;
    localStorage.setItem("tokenL", token);
    sessionStorage.setItem("token", token);
    setAuthToken(token);

    // Redirect immediately to /carte
    //window.location.href = "https://gexonline-r7.gexpertise.fr/carte";
    navigate("/carte");
  } catch (error) {
    console.error(error);
  }
};


  const rememberMe = localStorage.getItem("tokenL");

  const toLowerCase = (value) => (value ? value.toLowerCase() : "");

  if (rememberMe) {
    setAuthToken(rememberMe);
    return <Navigate to="/carte" replace />;
  } else
    return (
      <div className="grid loginPage">
        <Toast ref={toast} />
        <div className="login">
          <p className="presentation lg:col-2 lg:col-offset-2">
            GexOnline est l'offre digitale du Groupe{" "}
            <a href="https://www.gexpertise.fr" target="_blank" className="LinkGex" rel="noreferrer">
              GEXPERTISE
            </a>{" "}
            pour une information immobilière connectée proposant une interface simple et personnalisée.
            Retrouvez tous vos livrables en quelques clics.
          </p>

          <Card className="lg:col-2 lg:col-offset-1 cardLogin">
            <div className="card">
              <Form
                onSubmit={OnSubmit}
                initialValues={{ username: "", password: "", remember: false }}
                validate={validate}
                render={({ handleSubmit }) => (
                  <form onSubmit={handleSubmit} className="p-fluid">
                    <Field
                      format={toLowerCase}
                      parse={toLowerCase}
                      name="username"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-left">
                            <i className="pi pi-user" />
                            <InputText
                              id="username"
                              {...input}
                              placeholder="Email"
                              className={classNames("inputText", { "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="username"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Adresse mail*
                            </label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                    <Field
                      name="password"
                      render={({ input, meta }) => (
                        <div className="p-field">
                        <div className="password-field-container">
                          {/* Lock Icon */}
                          <i className="pi pi-lock lock-icon" />
                          {/* Password Input with Toggle */}
                          <span className="p-float-label p-input-icon-right p-input-icon-left">
                            <Password
                              id="password"
                              feedback={false}
                              {...input}
                              placeholder="Mot de passe"
                              toggleMask
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="password"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Mot de passe*
                            </label>
                          </span>
                        </div>
                        {getFormErrorMessage(meta)}
                      </div>
                      )}
                    />
                    <div className="field-checkbox-container">
                      <Field
                        name="remember"
                        type="checkbox"
                        render={({ input }) => (
                          <div className="p-field-checkbox">
                            <Checkbox id="remember" {...input} />
                            <label htmlFor="remember" className="SouvenirLabel">
                              Se souvenir de moi sur cet appareil
                            </label>
                          </div>
                        )}
                      />
                      <a href="/MotDePasseOublie" className="lien_login">
                        Mot de passe oublié ?
                      </a>
                    </div>

                    <div className="button-container">
                      <Button type="submit" label="Se connecter" className="p-mt-2 connect" disabled={mfaOpen} />
                    </div>
                    <div className="contact-container">
                      <span className="line"></span>
                      <span className="contact-text" onClick={handleLogin}>
                        Accès collaborateurs Gexpertise
                      </span>
                      <span className="line"></span>
                    </div>
                  </form>
                )}
              />
            </div>

            <center>
              <Button type="button" className="office" onClick={() => setDialog(true)}>
                Nous contacter
              </Button>
            </center>
          </Card>
        </div>

        <div className="loginFooter">
          <PiedPage />
        </div>

        {/* Password Reset Dialog */}
         <Dialog
  header="Vérifiez votre identité"
  visible={mfaOpen}
  modal
  dismissableMask
  className="custom-mfa-dialog"
  onHide={() => setMfaOpen(false)}
>
  <div
    className="p-fluid"
    style={{ display: "grid", gap: 12 }}
    // Empêche la touche Entrée de soumettre le <form> parent
    onKeyDown={(e) => {
      if (e.key === "Enter") e.preventDefault();
    }}
  >
    <div>
      <p style={{ marginTop: 0 }}>
        Nous avons envoyé un code à 6 chiffres à votre adresse email.<br />
        Saisissez ce code pour continuer.
      </p>

      {/* Champ OTP + bouton effacer */}
      <div className="otp-box" onPaste={handleOtpPaste} style={{ display: "flex", gap: 8,marginBottom:"25px" }}>
  {otpDigits.map((d, i) => (
    <InputText
      key={i}
      ref={otpRefs.current[i]}
      value={d}
      onChange={(e) => handleOtpChange(i, e.target.value)}
      onKeyDown={(e) => handleOtpKeyDown(i, e)}
      inputMode="numeric"
      pattern="[0-9]*"
      maxLength={1}
      className="otp-input"
      style={{
        width: 40,
        height: 48,
        textAlign: "center",
        fontSize: 20,
        fontWeight: 600,
      }}
    />
  ))}
  <Button
    type="button"
    icon="pi pi-times"
    className="p-button-text"
    onClick={() => { setOtpDigits(["","","","","",""]); setMfaCode(""); otpRefs.current[0]?.current?.focus(); }}
    disabled={mfaLoading || mfaCode.length === 0}
    aria-label="Effacer le code"
  />
</div>

      {/* Se souvenir de l'appareil */}
      <div className="p-field-checkbox" style={{ marginTop: 8 }}>
        <Checkbox
          inputId="rememberDevice"
          checked={rememberDevice}
          onChange={(e) => setRememberDevice(e.checked)}
          disabled={mfaLoading}
        />
        <label htmlFor="rememberDevice">Se souvenir de cet appareil </label>
      </div>
    </div>

    {/* Actions */}
    <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}>
      <Button
        type="button"                       // IMPORTANT: ne pas submit le form parent
        label={mfaLoading ? "Vérification..." : "Continuer"}
        className="p-button"   style={{ backgroundColor: "#b71c1c", borderColor: "#b71c1c", color: "#fff" }}
        onClick={handleVerifyMfa}
        disabled={mfaLoading || mfaCode.length !== 6}
      />
      <Button
        type="button"                       // IMPORTANT
        label="Renvoyer le code" style={{ backgroundColor: "#596169", borderColor: "#596169", color: "#fff", fontSize:"14.2px"}}
        className="p-button" 
        onClick={handleResendCode}
        disabled={mfaLoading}
      />
      <span style={{ flex: 1 }} />

    </div>

    <div>
     
    </div>
  </div>
</Dialog>


        <Dialog
          header="Contactez-nous"
          className="dialogHome"
          visible={openDialog}
          style={{ width: "100%", height: "100%" }}
          onHide={() => setDialog(false)}
        >
          <NousContacter setDialog={setDialog} />
        </Dialog>
      </div>
    );
}
